import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { withAppProps } from '@utils/with-app-props';
import { Box, Col, Container, Row } from '../../components/grid';
import { Breadcrumbs } from '../../components/breadcrumbs';
import { CheckGiftCardBalanceForm } from '../../components/check-gift-card-balance-form';
import { Layout } from '../../components/layout';
import { navigation } from '../../constants';

const CheckBalancePage = ({ title }) => {
  return (
    <Layout title={title}>
      <Container>
        <Breadcrumbs
          pt={1}
          entry={{
            title,
            ancestors: [
              {
                id: 'gift-cards-page',
                title: 'Gift Cards',
                url: navigation.GIFT_CARDS,
              },
            ],
          }}
        />
        <Row>
          <Col width={{ xs: 12 / 12, lg: 10 / 12, xl: 8 / 12 }} offset={[0, 0, 0, 1 / 12, 2 / 12]}>
            <Box px={2} pt={{ xs: 3, md: 4 }} pb={{ xs: 3, md: 5 }} backgroundColor="white">
              <CheckGiftCardBalanceForm />
            </Box>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

CheckBalancePage.propTypes = {
  title: PropTypes.string,
};

CheckBalancePage.defaultProps = {
  title: undefined,
};

export const getStaticProps = withAppProps(async () => {
  return {
    props: {
      title: 'Check Balance',
    },
  };
});

export default observer(CheckBalancePage);
